import { Link } from "react-router-dom";

export default function PagoCancelado() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, background: "#f9f9f9" }}>
      <div style={{ background: "white", padding: 40, borderRadius: 16, maxWidth: 520, width: "100%", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.1)" }} data-testid="pago-cancelado-card">
        <i className="fas fa-times-circle" style={{ fontSize: 72, color: "#f44336", marginBottom: 16 }} />
        <h2 style={{ margin: "16px 0" }}>Pago cancelado</h2>
        <p style={{ color: "#666" }}>No se realizó ningún cargo. Puedes intentar de nuevo cuando lo desees.</p>
        <Link to="/#planes" style={{ display: "inline-block", marginTop: 24, background: "#E84C5E", color: "white", padding: "12px 30px", borderRadius: 8, textDecoration: "none", fontWeight: 600 }} data-testid="pago-volver-planes-btn">
          Volver a los planes
        </Link>
      </div>
    </div>
  );
}
